import { buildIsServiceFn } from '../../utils';

import { SERVICE_TYPES_ORIGIN } from '../../constants';

const isOriginService = buildIsServiceFn(SERVICE_TYPES_ORIGIN);

export default isOriginService;
